<template>
  <div class="order-details-commerce-agent-fees">
    <div class="background" @click="close" />

    <div class="wrapper no-scrollbar">
      <div class="close-wrapper" @click="close">
        <button class="delete is-large" />
      </div>
      <div class="subtitle">{{ $t("Fees and Discounts") }}</div>

      <div class="fee">
        <span class="fee-name">Service Fee</span>
        <span class="price is-pulled-right"
          >− {{ currency }}{{ serviceFee }}</span
        >
      </div>

      <div v-if="lalamoveFee" class="fee">
        <span class="fee-name">{{ $t("delivery.delivery-fee") }}</span>
        <span class="price is-pulled-right"
          >+ {{ currency }}{{ lalamoveFee }}</span
        >
      </div>

      <div class="fee">
        <span class="fee-name">{{ $t("Discounts") }}</span>
        <span class="price is-pulled-right"
          >− {{ currency }}{{ fulfilmentDiscount }}</span
        >
      </div>
      <hr style="padding: 3px; margin: 0" />

      <div class="fee" style="font-size: 1.25em">
        <span class="fee-name">{{ $t("Net") }}</span>
        <span class="price is-pulled-right">
          <span v-if="net > 0">+</span>
          <span v-else>−</span>
          {{ currency }}{{ Math.abs(net) }}</span
        >
      </div>

      <div
        v-if="$store.getters.isSuperUser"
        class="notification"
        style="background-color: #aab; color: white; font-size: 1em"
      >
        <div class="fee">
          <span class="fee-name"
            >{{ $t("Billing") }}
            <!-- <i class="fa fa-mask" /> -->
          </span>
          <span class="price is-pulled-right"
            >{{ currency }}{{ billing || 0 }}</span
          >
        </div>
        <div class="fee has-text-weight-bold">
          <span class="fee-name">{{ $t("Total Collection EOM") }} </span>
          <span class="price is-pulled-right"
            >{{ currency }}{{ totalCollectionEOM }}</span
          >
        </div>
      </div>

      <div class="notification">
        <!-- <p style="margin-bottom: 8px">
          Your shop promotions like customer discounts appear here as negative
          line items.
        </p> -->
        <p>
          Please contact your TUK Account Manager if you have questions about
          fees and discounts.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    fulfilment: String, // delivery, take-away, dine-in
    fees: Object, // this is data.order object
    lalamoveFee: Number,
    billing: Number,
    currency: String,
  },
  data() {
    return {};
  },
  computed: {
    totalCollectionEOM() {
      return this.billing + this.lalamoveFee;
    },
    deliveryFee() {
      return this.fees.delivery_subsidy; // same as lalamoveFee, if lala
    },
    // special_discount is overflow from delivery subsidy on f_x_y billing
    serviceFee() {
      return this.fees.delivery_subsidy + this.fees.special_discount;
    },
    fulfilmentDiscount() {
      return this.fees.fulfilment_discount;
    },
    // don't count special discount here, could have other discount types later
    discounts() {
      return this.fulfilmentDiscount;
    },
    // simple net, not lalamove
    netNormal() {
      return -1 * this.serviceFee + -1 * this.discounts;
    },
    net() {
      if (this.lalamoveFee) return this.netNormal + this.lalamoveFee; // because we collect it later
      return this.netNormal;
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.order-details-commerce-agent-fees {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(128, 128, 128, 0.5);
  z-index: 21;
  backdrop-filter: blur(1px);
}
.background {
  position: absolute;
  top: 0;
  /* left: 0; */
  width: 100vw;
  height: 100vh;
}
.wrapper {
  position: absolute;
  bottom: 0;
  /* right: 0; */
  max-width: 600px;
  height: auto;
  max-height: calc(100vh - 60px);
  overflow: scroll;
  width: 100vw;
  overflow-x: hidden;
  padding: 12px;
  background-color: rgba(255, 255, 255, 0.95);
  text-align: left;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  box-shadow: 0 0 3px #444;
  padding-bottom: 24px;
}
.subtitle {
  font-size: 1.4em;
  font-weight: 500;
  margin-bottom: 12px;
}
.fee {
  padding: 8px;
}
.close-wrapper {
  /* position: absolute; */
  position: fixed;
  /* top: 0; */
  margin-top: -12px;
  right: 0;
  padding: 8px 12px;
  z-index: 2;
}
.required {
  margin-left: 6px;
  font-size: 0.8em;
  font-weight: 500;
  opacity: 0.7;
  background-color: rgba(232, 232, 232);
  border-radius: 3px;
  padding: 3px;
  /* color: red; */
}
.notification {
  margin-top: 8px;
  padding: 6px;
  font-size: 0.85em;
  /* color: grey; */
}
.fee-name {
  font-weight: 450;
  opacity: 0.7;
}
</style>